import { FC } from "react";

export const ArrowUpFullIcon: FC<{ className?: string }> = () => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66458 7.01099H0.335417C0.0555991 7.01099 -0.100645 6.71554 0.0726438 6.51385L4.73723 1.10498C4.87074 0.950154 5.12784 0.950154 5.26277 1.10498L9.92736 6.51385C10.1006 6.71554 9.9444 7.01099 9.66458 7.01099Z"
        fill="#1E163B"
      />
    </svg>
  );
};
